module.exports = __webpack_public_path__ + "static/img/t42.81e87024.png";